



















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Validate } from 'vuelidate-property-decorators'
import { emitEvent, unregisterEvent, registerEvent, AxEventType } from '@aspenware-library/event-hub'
import { Action, Getter } from 'vuex-class'
import { format } from 'date-fns'
import { CartUtils } from '@axCommerce/mixins/cart-utils'
import LoadingAnimation from '@axCommerce/components/loading-animation'
import ProductAttributesChips from '@axCommerce/components/product-attributes-chips'

@Component({
  name: 'MobileAddToCartBar',
  mixins: [CartUtils],
  components: { LoadingAnimation, ProductAttributesChips },
})
export default class MobileAddToCartBar extends Vue {
  @Getter('cart/showCartCard') showCartCard
  @Getter('global/currency') currency
  @Getter('global/labels') globalLabels
  @Getter('global/language') language
  @Getter('products/assignedToAttribute') assignedToAttribute
  @Getter('products/dateAttributes') productDateAttributes
  @Getter('products/selectedProductAttributes') productAttributes
  @Getter('products/productUpdating') updatingProduct
  @Getter('products/selectedProduct') product
  @Getter('products/selectedProductAttributes') selectedAttributes
  @Getter('products/selectedProductDateInventory') selectedDayInventoryCount
  @Getter('products/selectedProductIsRadioButtonDate') datesAsList
  @Getter('products/selectedProductMember') productMember
  @Getter('products/selectedProductPrice') selectedProductPrice

  @Action('products/clearProductAssignment') clearProductAssignment
  @Action('cart/toggleCartCard') toggleCartCard

  @Prop({ default: '' })
  private externalPrice: string
  @Prop({ default: false })
  private useExternalPrice: boolean
  @Prop({ default: false })
  private displayBreakpoint: boolean
  private couldNotObtainLock: boolean = false
  private addToCartDisabled: boolean = false
  @Getter('cart/cartAdding') addingToCart

  @Validate({
    validRenewal(value) {
      return !value
    },
  })
  get isRenewal(): boolean {
    return false
  }

  @Validate({
    $each: {
      validRequired(value) {
        if (value.IsRequired) {
          if (value.SelectedValue || value.SelectedValueId) {
            if (value.SelectedValueId) {
              return value.SelectedValueId !== 0 // Attribute values use 0 as an unselected value.
            }
            return value.SelectedValue && value.SelectedValue.toString().length > 0
          }
        } else {
          return true
        }

        return false
      },
    },
    validDate(value) {
      if (value) {
        const dateAttr = value.find((attr) => attr.IsDate)
        if (dateAttr) {
          if (!this.datesAsList && (!dateAttr.SelectedValueId || dateAttr.SelectedValueId.toString().length < 1)) {
            return false
          }
        }
      }

      return true
    },
    validActivityTime(value) {
      if (value) {
        for (let attribute of value) {
          if (attribute.IsActivityTime && (!attribute.SelectedValueId || attribute.SelectedValueId.length < 1)) {
            return false
          }
        }
      }

      return true
    },
    validListDate(value) {
      if (value) {
        var hasDate = value.some((attribute) => {
          return attribute.IsDate && attribute.SelectedValue
        })

        return this.datesAsList ? hasDate : true
      }

      return true
    },
    validReload(value) {
      if (value) {
        var reloadSelected = this.$store.getters['products/selectedProductIsReloading']

        if (reloadSelected) {
          return !!this.selectedMemberId
        }
      }

      return true
    },
  })
  get selectedAttributesForDisplay(): any[] {
    return this.selectedAttributes.filter((attr) => !attr.Disabled)
  }

  get labels(): any {
    return this.globalLabels?.ShoppingCart || {}
  }

  get originalPrice(): any {
    if (this.hasPricingAvailable && this.oldPriceAsNum != 0 && this.oldPriceAsNum > this.newPriceAsNum) {
      const originalPriceNumber = this.getSimpleNumber(this.product.ProductPrice.OldPrice)
      return this.$options.filters.removeCurrencyFraction(originalPriceNumber, this.language, this.currency)
    }

    return null
  }

  get productPrice() {
    var price = this.selectedProductPrice
    if (price && _.endsWith(price, '.00')) {
      price = price.substring(0, price.length - 3)
    }
    return price
  }

  get hideDynamicPrice(): boolean {
    return this.isDynamicPricing && !this.product.DynamicPriceSet
  }

  get isDynamicPricing(): boolean {
    return this.product.IsDynamicPriceDaysToArrival ? this.product.IsDynamicPriceDaysToArrival : false
  }

  public async addToCart(): Promise<void> {
    try {
      const result = await this.$store.dispatch('cart/addToCart', {
        productId: this.product.Id,
        productAttributes: this.product.ProductAttributes,
      })

      this.getCartData(null, true, this.onCartReload)
    } catch (error) {
      this.cartError = error.response.data.message[0]
    } finally {
    }
  }
}
